import { Component, OnInit } from '@angular/core';
import { AbstractFormWidgetComponent } from '../abstract-form-widget/abstract-form-widget.component';
import { SearchService } from '../../../search/search.service';
import { CommodityButtonService } from '../../../../features/setup/customer/commodity/service/commodity-button.service';
import { CommodityDataService } from '../../../../features/setup/customer/commodity/service/commodity-data.service';
import { PAGE_OVERFLOW_EVENT, NEW_ROW_EVENT, NEW_SEARCH_EVENT } from '../../../search/search-constants';
import { SearchEvent } from '../../../search/models/search-event';
import { SearchCriteria } from '../../../search/models/search-filter-model';

@Component({
  selector: 'lfwms-commodity-advance-sku-widget',
  templateUrl: './commodity-advance-sku-widget.html',
  styleUrls: ['./commodity-advance-sku-widget.css']
})
export class CommodityAdvanceSkuWidgetComponent extends AbstractFormWidgetComponent implements OnInit {
  public searchService: SearchService;
  public dataService: CommodityDataService;
  public buttonService: CommodityButtonService;
  public ngOnInit() {
    this.buttonService = <CommodityButtonService> this.pageConfig.buttonService;

    this.initializeWidget();
    this.searchService.receiveEvent()
      .subscribe((event: SearchEvent) => {
        this.buttonService.initializeButtonsForPage(this.cellDataMap, 'details');
        if (event.type === NEW_SEARCH_EVENT &&
          this.searchService.getMetadata()) {
          // For NEW_SEARCH_EVENT, the Details Data Table will be displayed
          this.pageConfig.isDetailSectionLoaded = true;
        } else if (event.type === NEW_ROW_EVENT) {
          const newRow = event.selectedRow.cells;

          if (newRow['storerKey'] || newRow['sku']) {
            newRow['storerKey'].cVal = this.dataService.primaryDataMap['storerKey'].cVal;
            newRow['sku'].cVal = this.dataService.primaryDataMap['sku'].cVal;
          }
          // For NEW_ROW_EVENT
          // for new row event the search service should also be passed to distinguish between the two tables
          // this.dataService.handleAddNewItem(event, this.searchService);
        } else if (event.type === PAGE_OVERFLOW_EVENT) {
          // This event comes when a page overflow has occured. Save the corrent page and navigate to the next
          // page on success
          this.searchService.setNewPageEventInProgress(true);
          this.buttonService.performButtonActions('Save');
        }
      });
  }

  protected initializeWidget() {
    // this is not to be loaded from the primary data map, hence initializing it
    // this.pageConfig.cellDataMap = {};
    super.initializeWidget();

    this.searchService = this.dataService.getSearchServiceForColumnGroup(this.widgetConfig.id);
    this.searchService.clearSearchStatus();
    // LFWM: 1734 - Restricting Sku Alias columns in edit mode
    if (this.widgetConfig.id === 'SKU Alias/UPC') {
     /**
      * If the table is in View Mode make all columns as non editable
      * In the Edit Mode, make columns editable based on its metadata
      * In Create Mode, make all columns as editable
      */
      this.searchService.searchParams.dataTableConfig.isColumnEditable = function (params: any) {
        const rowData = params.data;
        const componentRef = params.context.componentParent;
        // if the table is in view mode, do not make any column as editable
        if (['V', 'P'].indexOf(componentRef.tableMode) !== -1) {
          return false;
        }
        // LFWM-4587 added qty filed as editable
        const editableCols = ['upc', 'packKey', 'uom', 'qty'];
        const editableColsAfterEdit = ['qty']
        const isNewRow: boolean = rowData && rowData['isNewItem'] && rowData['isNewItem'].cVal;
        // if this is a new row then all columns will be editable
        if (isNewRow) {
          return editableCols.indexOf(params.colDef.colId) !== -1;
        } else {
          // return false;
          return editableColsAfterEdit.indexOf(params.colDef.colId) !== -1;
        }
      };
    }
    if (this.dataService.displayMode === 'C') {
    } else {
      this.searchService.setSearchCriteria(new SearchCriteria());
      this.searchService.setSearchCriteria({
        conditions: [{
          mandatory: false,
          clauses: [{
            column: 'sku',
            operation: '=',
            value: this.dataService.primaryDataMap['sku'].cVal,
            logicalOperation: null
          },
          {
            column: 'storerKey',
            operation: '=',
            value: this.dataService.primaryDataMap['storerKey'].cVal,
            logicalOperation: 'AND'
          }],
          logicalOperation: null
        }]
      });
      this.searchService.performSearch();
    }
  }

  // realigns the widget
  public realignWidget() {
    //  this.propertyList = this.preparePropertyGrid(this.widgetConfig.propertyList, this.getCellsPerRow());
  }

}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/widget/commodity-advance-sku-widget/commodity-advance-sku-widget.ts